export abstract class Measure {
  measureList: Array<any>;
  dateList: Array<Date>;
  assetId: string;
  type: string;
  reference: string;

  constructor(
    measureList: Array<any>,
    dateList: Array<Date>,
    assetId: string,
    type: string,
    reference: string
  ) {
    this.measureList = measureList;
    this.dateList = dateList;
    this.assetId = assetId;
    this.type = type;
    this.reference = reference;
  }
}
